<template>
  <div
    :class="[
      'ftn-loader',
      `ftn-loader_color-${color}`,
      `ftn-loader_size-${size}`,
    ]"
  ></div>
</template>

<script>
export const COLORS = {
  GRAY: 'gray',
  GRAY_LIGHT: 'gray-light',
  WHITE: 'white',
  BLUE: 'blue',
};

const SIZES = {
  DEFAULT: 'default',
  SMALL: 'small',
};

export default {
  name: 'Loader',
  props: {
    color: {
      default: COLORS.GRAY,
      validator(value) {
        return Object.values(COLORS).includes(value);
      },
    },
    size: {
      default: SIZES.DEFAULT,
      validator(value) {
        return Object.values(SIZES).includes(value);
      },
    },
  },
};
</script>

<style lang="scss">
@mixin set-color($color) {
  &::before {
    border-color: $color;
    border-bottom-color: transparent;
  }
}

@mixin set-size($size, $border-size) {
  &::before {
    width: $size;
    height: $size;

    border-width: $border-size;
  }
}

.ftn-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  padding: 24px;

  &::before {
    content: "";
    border-style: solid;
    border-radius: 50%;

    animation: rotate calc(var(--duration) * 4) linear infinite;
  }

  &_color {
    &-gray {
      @include set-color(var(--gray-1));
    }

    &-gray-light {
      @include set-color(var(--gray-3));
    }

    &-white {
      @include set-color(#ffffff);
    }

    &-blue {
      @include set-color(var(--blue));
    }
  }

  &_size {
    &-default {
      @include set-size(24px, 5px);
    }

    &-small {
      @include set-size(12px, 3px);
      padding: 0;
    }
  }
}
</style>
